/*
 * @Descripttion:
 * @version:
 * @Author: yemingyi
 * @Date: 2020-09-28 17:18:53
 * @LastEditors: susj
 * @LastEditTime: 2020-12-01 10:47:31
 */
/* eslint-disable */
import Element from '@/components/core/models/element';
import Page from '@/components/core/models/page';
import Work from '@/components/core/models/work';

import { SCHEME_TYPE } from '@/constants';
import {
  getSchemeInfoAndList,
  getTemplateList,
  collectTemplate,
  unCollectTemplate,
  createScheme,
  deleteScheme,
  getPptBrief,
  getPptShare,
} from '@/services/modules/scheme';

import { asyncData2workData } from '@/utils/work';

const state = {
  schemeInfo: null,
  mySchemeList: [],
  companySchemeList: [],
  systemSchemeList: [],
  collectSchemeList: [],
  pptBrief: null,
  pptShare: null,
};

const getters = {};

const actions = {
  // 获取方案信息和方案秀列表
  async getSchemeInfoAndList({ commit }, payload) {
    const { success, result } = await getSchemeInfoAndList(payload);
    if (success && result) {
      commit('setSchemeInfo', result);
    }
    return success;
  },
  // 获取模板列表
  async getTemplateList({ commit }, payload) {
    const { success, result } = await getTemplateList(payload);
    if (success) {
      commit('setSchemeList', { result, payload });
    }
    return success;
  },
  // 获取分享预览资源&方案模板及方案秀的详细信息
  async getPptBrief({ commit }, payload) {
    const { success, result } = await getPptBrief(payload);
    if (success && result) {
      commit('setPptBrief', result);
      return result
    }
  },
  // 获取分享预览资源
  async getPptShare({ commit }, payload) {
    const { success, result } = await getPptShare(payload);
    if (success && result) {
      const newRsult = asyncData2workData(result);
      commit('setPptShare', newRsult);
      return newRsult;
    }
  },
  // 创建方案秀
  async createScheme({ commit }, payload) { // eslint-disable-line
    const { success, result } = await createScheme(payload);
    if (success && result) {
      return result;
    }
    return false;
  },
  // 删除方案秀
  async deleteScheme({ commit }, payload) {
    const { success, result } = await deleteScheme(payload);
    return success;
  },
  // 收藏模板
  async collectTemplate({ commit }, payload) { // eslint-disable-line
    const { success, result } = await collectTemplate(payload);
    if (success && result) {
      return true;
    }
    return false;
  },
  async unCollectTemplate({ commit }, payload) { // eslint-disable-line
    const { success, result } = await unCollectTemplate(payload);
    if (success && result) {
      return true;
    }
    return false;
  },
};

const mutations = {
  setSchemeInfo(state, result) {
    state.schemeInfo = result.designSchemeResult || null;
    state.mySchemeList = result.pptResultDtoList || [];
  },
  setMySchemeList(state, result) {
    state.mySchemeList = result;
  },
  setSchemeList(state, { result, payload }) {
    if (payload.type === SCHEME_TYPE.COMPANY) {
      state.companySchemeList = result || [];
    } else if (payload.type === SCHEME_TYPE.SYSTEM) {
      state.systemSchemeList = result || [];
    } else if (payload.type === SCHEME_TYPE.COLLECTION) {
      state.collectSchemeList = result || [];
    }
  },
  setPptShare(state, work) {
    // state.pptShare = result || null;
    window.__work = work;
    work.pages = work.pages.map((page) => {
      page.elements = page.elements.map(element => new Element(element));
      return new Page(page);
    });
    state.pptShare = new Work(work);
  },
  setPptBrief(state, result) {
    state.pptBrief = result || null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
